import { authHeader, host, history } from '../_helpers';
import axios from 'axios';

import { alertActions } from '../_actions';

export const userService = {
    login,
    logout,
    getEntitlements, 
    changePassword,
    downloadEFPCS2Specs, 
    getVersion
};


	
function login(username, password) {
    
    let buff = new Buffer(username + ':' + password);
    let stringToBase64 = buff.toString('base64');
    //console.log("buff : " + buff);
    //console.log("stringToBase64: " + stringToBase64);

    const authBasic = { 'Content-Type': 'text/plain' , 'Authorization': 'Basic ' + stringToBase64 };
    return axios.post(`${host}/EFPServices/rest/users`, username, { headers: authBasic })
    .then(response => {
        localStorage.setItem('user', JSON.stringify(response.data));
        return response.data;
    });

}

function getEntitlements(userId) {
    

    console.log("Authheader : ==================================:) " + JSON.stringify(authHeader()));
    
            
    return axios.post(`${host}/EFPServices/rest/users/entitlements`, userId, { headers: authHeader() })
    .then(response => {
        
        const assignedRoles = [];
        response.data.efpGroupMembers.map((efpGroupMember) => {
            assignedRoles.push(efpGroupMember.listName)
        
        })	
            localStorage.setItem('assignedRoles', JSON.stringify(assignedRoles));
            
            return response.data;
        });
        
}

function getVersion() {

    return axios.get(`${host}/EFPServices/rest/efp/version/`, { headers: authHeader() })
    .then(response => {
        localStorage.setItem('version', response.data.version)
        return response.data;
    });
    
}

function changePassword(inputs) {
 
    return axios.post(`${host}/EFPServices/rest/users/changepassword`, inputs, { headers: authHeader() })
    .then(response => {
        return response.data;
    });
    
}


function logout() {

    // remove user from local storage to log user out
    localStorage.removeItem('user');
    localStorage.removeItem('assignedRoles');
    const { from } = location.state || { from: { pathname: "/login" } };
    history.push(from);
    
}

function downloadEFPCS2Specs(userId) {

     console.log("Authheader : ==================================:) " + JSON.stringify(authHeader()));
    var header = authHeader();
    header.responseType = 'arraybuffer';
    //header["Content-Type"] = 'application/json;charset=UTF-8';

           
    return axios.post(`${host}/EFPServices/rest/cs2/download/cs2specs/`, userId, { headers: header })
    .then(response => {
        console.log("successfully downloaded cs2specs from server: ");
						 var deferStr = '';
						 var blob = new Blob([response.data], {
                                type: 'application/msword'
                                //type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
						    });
						 if (blob.size > 0){
							 if (window.navigator && window.navigator.msSaveOrOpenBlob) {
								    window.navigator.msSaveOrOpenBlob(blob);
								    deferStr = 'success';
							} else { 
								var objectUrl = URL.createObjectURL(blob);						 
							    window.open(objectUrl, '_self'); 
							    deferStr = 'success';
							}
						} else {
							 //deferred.reject("CS2Specs not available");
							 deferStr = 'fail';
						 }
            return response.data;
        });

}


function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        console.log("handleResponse in user service: "+ data);
        return data;
    });
}